(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cdc-fabrica-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('cdc-factory-video')) return;

    class CDCFactoryVideo extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true, signal: this.abort.signal });
        } else {
          this.init();
        }
      }

      init() {
        if (!this.isConnected || this.initialized) return;
        this.initialized = true;
        const signal = this.abort.signal;
        this.poster = this.querySelector('[data-cdc-play]');
        this.mount = this.querySelector('[data-cdc-mount]');
        this.closeButton = this.querySelector('[data-cdc-close]');
        this.errorBox = this.querySelector('[data-cdc-error]');
        this.status = this.querySelector('[data-cdc-status]');
        try {
          this.sources = JSON.parse(this.querySelector('[data-cdc-sources]')?.textContent || '[]');
        } catch (_) {
          this.sources = [];
        }
        if (!Array.isArray(this.sources)) this.sources = [];
        this.sources = this.sources.filter(source => source && typeof source.url === 'string' && source.url.length > 0);
        this.poster?.addEventListener('click', event => {
          if (!this.sources.length) return;
          event.preventDefault();
          this.start();
        }, { signal });
        this.closeButton?.addEventListener('click', () => this.stop(true), { signal });
        this.querySelector('[data-cdc-retry]')?.addEventListener('click', () => { this.stop(false); this.start(); }, { signal });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden && this.player) this.player.pause();
        }, { signal });
        this.initFont();
      }

      initFont() {
        if (this.dataset.loadFont !== 'true' || this.dataset.brandFont !== 'true') return;
        const load = () => {
          this.fontObserver?.disconnect();
          if (document.querySelector('link[data-cdc-factory-font], link[href*="fonts.googleapis.com"][href*="family=Anton"]')) return;
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = 'https://fonts.googleapis.com/css2?family=Anton&display=swap';
          link.dataset.cdcFactoryFont = 'true';
          document.head.appendChild(link);
        };
        if ('IntersectionObserver' in window) {
          this.fontObserver = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) load();
          }, { rootMargin: '0px' });
          this.fontObserver.observe(this);
        }
      }

      selectSources(player) {
        const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        const constrained = Boolean(connection?.saveData || /(^|-)2g$|^3g$/.test(connection?.effectiveType || ''));
        const cap = constrained ? 480 : Math.min(Number(this.dataset.quality) || 720, 1080);
        const mp4 = this.sources.filter(source => source.format === 'mp4' || source.mime_type === 'video/mp4').sort((a, b) => (Number(a.height) || 0) - (Number(b.height) || 0));
        const compatible = mp4.filter(source => (Number(source.height) || 0) <= cap);
        const progressive = compatible.at(-1) || mp4[0];
        const hls = this.sources.find(source => source.format === 'm3u8' || /mpegurl/i.test(source.mime_type || ''));
        const nativeHls = player.canPlayType('application/vnd.apple.mpegurl') || player.canPlayType('application/x-mpegURL');
        if (!constrained && hls && nativeHls) return { primary: hls, backup: progressive };
        return { primary: progressive || (nativeHls ? hls : null), backup: null };
      }

      start() {
        if (this.player || !this.mount || !this.sources.length) return;
        document.querySelectorAll('cdc-factory-video').forEach(other => {
          if (other !== this && typeof other.stop === 'function') other.stop(false);
        });
        const player = document.createElement('video');
        const selected = this.selectSources(player);
        if (!selected.primary) {
          this.errorBox.hidden = false;
          this.status.textContent = 'Este navegador não conseguiu abrir o vídeo.';
          this.closeButton.hidden = false;
          return;
        }
        this.player = player;
        this.playbackAbort = new AbortController();
        player.className = 'cdcFactory__player';
        player.controls = true;
        player.playsInline = true;
        player.preload = 'none';
        player.setAttribute('playsinline', '');
        player.setAttribute('aria-label', this.dataset.videoLabel || 'Vídeo da fábrica da Casa da Construção');
        player.tabIndex = 0;
        player.addEventListener('error', () => {
          if (this.player !== player) return;
          if (selected.backup) {
            const backup = selected.backup;
            selected.backup = null;
            player.src = backup.url;
            this.tryPlay(player);
          } else {
            this.errorBox.hidden = false;
            this.status.textContent = 'Não foi possível iniciar o vídeo. Você pode tentar novamente.';
          }
        }, { signal: this.playbackAbort.signal });
        player.addEventListener('playing', () => {
          if (this.player === player) this.status.textContent = 'Vídeo em reprodução.';
        }, { signal: this.playbackAbort.signal });
        this.dataset.state = 'active';
        this.errorBox.hidden = true;
        this.poster.hidden = true;
        this.closeButton.hidden = false;
        this.mount.appendChild(player);
        this.status.textContent = 'Abrindo o vídeo.';
        player.src = selected.primary.url;
        this.tryPlay(player);
        player.focus({ preventScroll: true });
      }

      tryPlay(player) {
        const attempt = player.play();
        if (attempt && typeof attempt.catch === 'function') {
          attempt.catch(error => {
            if (this.player !== player || error.name === 'AbortError') return;
            if (error.name === 'NotAllowedError') this.status.textContent = 'Use o botão de reprodução do vídeo para começar.';
          });
        }
      }

      stop(restoreFocus = false) {
        this.playbackAbort?.abort();
        this.playbackAbort = null;
        if (this.player) {
          const player = this.player;
          this.player = null;
          player.pause();
          player.removeAttribute('src');
          player.load();
          player.remove();
        }
        this.dataset.state = 'idle';
        if (this.poster) this.poster.hidden = false;
        if (this.errorBox) this.errorBox.hidden = true;
        if (this.closeButton) this.closeButton.hidden = true;
        if (this.status) this.status.textContent = '';
        if (restoreFocus) this.poster?.focus({ preventScroll: true });
      }

      disconnectedCallback() {
        this.stop(false);
        this.fontObserver?.disconnect();
        this.abort?.abort();
        this.abort = null;
        this.initialized = false;
      }
    }
    customElements.define('cdc-factory-video', CDCFactoryVideo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
